import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import classes from './style.module.scss';

export default function Empty({ text, onClick, buttonText }) {
  return (
    <div className={classes.container}>
      <div className={classes.text}>{text}</div>
      <div className={classes.buttonContainer}>
        <Button onClick={onClick}>{buttonText}</Button>
      </div>
    </div>
  );
}

Empty.propTypes = {
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
